import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { DateContainer } from "../dateContainer/DateContainer";
import { useCourtBookingStore } from "../../stores/StoreContext";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { REQUEST_PLAYER_DATES_LIST_COUNT } from "../../utils/constants";
import { Colors } from "../../utils/colors";
import calender from "../../assets/calender.png";
import calender_dark from "../../assets/calender_dark.png";
import { TCText } from "../TCText/TCText";

type props = {};

export const DatesList: React.FC<props> = observer(() => {
  const courtBookingStore = useCourtBookingStore();
  const [showCalendar, setShowCalendar] = useState(false);

  useEffect(() => {
    // Initialize dates if needed
    if (courtBookingStore.nextSixDays.length === 0) {
      courtBookingStore.generateNextSixDays();
    }
  }, [courtBookingStore]);

  // Updated function to handle the correct type from react-calendar
  const handleCalendarSelect = (value: Date | null) => {
    if (value !== null) {
      const selectedDate = value;
      courtBookingStore.addCustomDate(selectedDate);
      setShowCalendar(false);
    }
  };
  const isCalendarSelected =
    courtBookingStore.nextSixDays.length > REQUEST_PLAYER_DATES_LIST_COUNT &&
    courtBookingStore.selectedDate?.fullDate ===
      courtBookingStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT].fullDate;

  return (
    <div style={{ marginTop: 15 }}>
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "10px", // Adds spacing between items
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          msOverflowStyle: "none", // Hides scrollbar in IE
        }}>
        {courtBookingStore.nextSixDays
          .slice(0, REQUEST_PLAYER_DATES_LIST_COUNT)
          .map((dateInfo, index) => (
            <DateContainer key={index} dateInfo={dateInfo} />
          ))}

        {/* Custom date option */}
        <div
          onClick={() => setShowCalendar(!showCalendar)}
          style={{
            minWidth: 56,
            height: 64,
            borderRadius: 16,
            backgroundColor: isCalendarSelected
              ? Colors.green
              : Colors.lightGreyBackground,
            color: "white",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}>
          <img
            src={isCalendarSelected ? calender : calender_dark}
            alt="My"
            width={isCalendarSelected ? 20 : 35}
            height={isCalendarSelected ? 21 : 35}
          />
          {isCalendarSelected && (
            <>
              <TCText
                style={{ fontWeight: 600, fontSize: 10, marginTop: 2 }}
                value={`${courtBookingStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT].day} ${courtBookingStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT].date}`}
              />

              <div style={{ fontWeight: 500, fontSize: 8 }}>
                {
                  courtBookingStore.nextSixDays[REQUEST_PLAYER_DATES_LIST_COUNT]
                    .month
                }
              </div>
            </>
          )}
        </div>
      </div>

      {/* Calendar popup */}
      {showCalendar && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            backgroundColor: "white",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            borderRadius: "8px",
            marginTop: "10px",
          }}>
          <Calendar
            onChange={(value) => {
              handleCalendarSelect(value as Date | null);
            }}
            defaultValue={courtBookingStore.selectedDate?.fullDate}
            minDate={courtBookingStore.getCalenderMinDate()}
            maxDate={new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)} // 90 days from now
          />
        </div>
      )}
    </div>
  );
});
